<template>
    <section id="attendants" class="attendants-block">
        <v-container class="block-container">
            <div class="section-meta">
                <span class="chapter-num">02</span>
                <span class="chapter-divider"></span>
                <span class="chapter-eyebrow">{{ $t('team.attendants.title') }}</span>
            </div>

            <h2 class="block-title" v-html="$t('team.page.attendants_headline')"></h2>

            <div class="attendants-grid">
                <div
                    v-for="(attendant, index) in attendants"
                    :key="index"
                    class="attendant-card">
                    <div class="card-media">
                        <img :src="attendant.picture" :alt="attendant.name" />
                    </div>
                    <div class="card-content">
                        <span class="card-role">{{ $t(attendant.roleKey) }}</span>
                        <h3 class="card-name">{{ attendant.name }}</h3>
                        <p class="card-bio">{{ $t(attendant.description) }}</p>
                    </div>
                </div>
            </div>
        </v-container>
    </section>
</template>

<script>
export default {
    name: "AttendantsComponent",
    data() {
        return {
            attendants: [
                {
                    picture: require('@/assets/img/components/team/coordinators/Sornek3.webp'),
                    name: 'dr hab. inż. Krzysztof Sornek, prof. AGH',
                    roleKey: 'team.attendants.role_scientific',
                    description: 'team.attendants.sornek'
                },
                {
                    picture: require('@/assets/img/components/team/coordinators/Sajdak2.webp'),
                    name: 'Mgr inż. Wojciech Sajdak',
                    roleKey: 'team.attendants.role_team',
                    description: 'team.attendants.sajdak'
                }
            ]
        }
    }
}
</script>

<style lang="sass" scoped>
    .attendants-block
        background: #faf7f1
        color: #0a0828
        padding: 160px 0
        font-family: Inter, sans-serif
        position: relative

        &::before
            content: ''
            position: absolute
            top: 0
            left: 56px
            width: 80px
            height: 1px
            background: rgba(10, 8, 40, 0.25)

    .block-container
        max-width: 1280px !important
        padding: 0 56px !important
        position: relative

    .section-meta
        display: flex
        align-items: center
        gap: 18px
        margin-bottom: 36px
        font-size: 12px
        font-weight: 500
        letter-spacing: 0.22em
        text-transform: uppercase
        color: #0a0828

        .chapter-num
            font-family: Raleway, sans-serif
            font-weight: 700
            font-size: 14px
            letter-spacing: 0.1em
            color: #0a0828

        .chapter-divider
            width: 36px
            height: 1px
            background: #0a0828
            opacity: 0.4

        .chapter-eyebrow
            opacity: 0.85

    .block-title
        font-family: Raleway, sans-serif
        font-weight: 900
        font-size: clamp(40px, 6vw, 88px)
        line-height: 0.98
        letter-spacing: -0.025em
        margin: 0 0 96px
        color: #0a0828
        text-transform: lowercase

    .attendants-grid
        display: grid
        grid-template-columns: 1fr 1fr
        gap: 56px
        align-items: start

    .attendant-card
        display: grid
        grid-template-rows: auto auto 1fr
        height: 100%

        .card-media
            position: relative
            text-align: center
            border-bottom: 1px solid rgba(10, 8, 40, 0.15)
            display: flex
            align-items: flex-end
            justify-content: center
            height: 420px
            min-height: 420px
            padding-bottom: 0

            img
                width: 100%
                max-width: 400px
                max-height: 400px
                height: auto
                object-fit: contain
                object-position: bottom center
                display: block
                margin: 0 auto

        .card-content
            display: flex
            flex-direction: column
            gap: 10px
            text-align: center
            padding: 28px 12px 0
            min-height: 280px

            .card-role
                font-size: 11px
                font-weight: 500
                letter-spacing: 0.22em
                text-transform: uppercase
                color: rgba(10, 8, 40, 0.6)
                min-height: 2.6em
                display: flex
                align-items: center
                justify-content: center

            .card-name
                font-family: Raleway, sans-serif
                font-weight: 800
                font-size: clamp(22px, 2.2vw, 30px)
                line-height: 1.2
                letter-spacing: -0.015em
                margin: 0
                color: #0a0828
                min-height: calc(3 * 1.2em)
                display: flex
                align-items: center
                justify-content: center

            .card-bio
                font-size: 15px
                line-height: 1.7
                color: rgba(10, 8, 40, 0.72)
                margin: 8px auto 0
                text-indent: 0
                max-width: 540px
                text-align: left
                flex: 1

    @media (max-width: 960px)
        .attendants-block
            padding: 110px 0

            &::before
                left: 28px

        .block-container
            padding: 0 28px !important

        .block-title
            margin-bottom: 64px

        .attendants-grid
            grid-template-columns: 1fr
            gap: 80px

        .attendant-card
            .card-media
                height: 360px
                min-height: 360px

                img
                    max-width: 320px
                    max-height: 320px

            .card-content
                min-height: 0
</style>
